export default Object.freeze({
  New: 1,
  Approved: 2,
  Denied: 3,
  ApprovedModified: 4,
  Submitted: 5,
  ProcessCompleted: 6,
  RequestRejected: 7,
  CompletedPendingApproval: 8,
  ReturnedToSupplier: 9,
  ExcludedByStrategy: 10,
  ExcludedGraduated: 11,
  ExcludedServiceHigh: 12,
  RequestCompleted: 13,
  ProcessDiscussion: 14,
});
